import React, { Component } from "react";
import Grid from "@mui/material/Grid";
import { Breadcrumbs, Typography } from "@mui/material";
import Link from "@mui/material/Link";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import CtBtn from "../Components/CustomTool/CtBtn";
import CtTxt from "../Components/CustomTool/CtTxt";
import TextEditor from "./TextEditor";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { withRouter } from "../HOC/withRouter";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";

class AMCMailPreview extends Component {
  state = {
    formData: {
      txtFrom: "noreply@topindia.com",
      txtTo: "",
      txtSubject: "",
      txtCC: "",
      txtBCC: "",
      txtMailContent: "",
    },
  };

  componentDidMount() {
    document.title = "AMC Mail Preview";
    localStorage.setItem("Heading", "AMC Mail Preview");
    this.props.verifyUserID(this.getInfo, this.props.setUserPrivileges);
  }

  getInfo = () => {
    document.getElementById("txtTo")?.focus();
  };

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleMailContentChange = (ctrlInfo) => {
    if (ctrlInfo && ctrlInfo.id === "txtMailContent") {
      this.setState({
        formData: { ...this.state.formData, txtMailContent: ctrlInfo.value },
      });
    }
  };

  sendMail = () => {
    const { txtFrom, txtTo, txtSubject, txtMailContent } = this.state.formData;
    if (!txtFrom) {
      this.props.toastErrorMsg("Enter From", "txtFrom");
      return;
    }
    if (!txtTo) {
      this.props.toastErrorMsg("Enter To", "txtTo");
      return;
    }
    if (!txtSubject) {
      this.props.toastErrorMsg("Enter Subject", "txtSubject");
      return;
    }
    if (!txtMailContent) {
      this.props.toastErrorMsg("Enter Mail Content", "");
      return;
    }
    this.props.toastMsg("success", "Mail Sent Successfully");
  };

  render() {
    const { formData } = this.state;
    return (
      <form>
        {/* <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="#/Dashboard">
            Dashboard
          </Link>
          <Link underline="hover" color="inherit" href="#/AMCDashboard">
            AMC Dashboard
          </Link>
          <Typography sx={{ color: "text.primary" }}>Mail Preview</Typography>
        </Breadcrumbs> */}

        <Grid container spacing={2} marginTop={2}>
          <Grid item>
            <CtTxt
              id="txtFrom"
              label="From*"
              value={formData.txtFrom}
              handleOnChange={this.handleOnChange}
              width={220}
              maxLength={100}
              disabled={true}
            />
          </Grid>
          <Grid item>
            <CtTxt
              id="txtTo"
              label="To*"
              value={formData.txtTo}
              handleOnChange={this.handleOnChange}
              width={220}
              maxLength={100}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID={"txtSubject"}
            />
          </Grid>
          <Grid item>
            <CtTxt
              id="txtSubject"
              label="Subject*"
              value={formData.txtSubject}
              handleOnChange={this.handleOnChange}
              width={220}
              maxLength={200}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID={"txtCC"}
            />
          </Grid>
          <Grid item>
            <CtTxt
              id="txtCC"
              label="CC"
              value={formData.txtCC}
              handleOnChange={this.handleOnChange}
              width={220}
              maxLength={200}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID={"txtBCC"}
            />
          </Grid>
          <Grid item>
            <CtTxt
              id="txtBCC"
              label="BCC"
              value={formData.txtBCC}
              handleOnChange={this.handleOnChange}
              width={220}
              maxLength={200}
              onKeyDown={this.props.onKeyDown}
              // nextCtrlID={"txtMailContent"}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography sx={{ color: "text.primary", bold: true }}>
              Mail Content*
            </Typography>
            <TextEditor
              id="txtMailContent"
              onEditorStateChange={this.handleMailContentChange}
            />
          </Grid>
          <Grid item>
            <CtBtn
              label="Send Mail"
              className="secondary-button"
              onClick={this.sendMail}
            />
          </Grid>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  const navigate = useNavigate();
  return <AMCMailPreview {...props} navigate={navigate} />;
}

export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
